import { graphql } from 'react-apollo'
import { ApplicationError } from '../../helpers/errors'
import { PRODUCTS } from '../../paths'
import query from './query.graphql'

export { query }

const DEFAULT_DEPTH = 2

export const mapPropsToOptions = ({
  subcategoryDepth = DEFAULT_DEPTH,
  filterState = { categoryPath: 'products' },
  categoryPath,
}) => ({
  errorPolicy: 'ignore',
  variables: {
    path: categoryPath || filterState.categoryPath,
    depth: subcategoryDepth,
  },
})

export const mapDataToProps = ({
  data: { error, loading, productCategories, categoriesHierarchy },
}) => {
  if (error) {
    return {
      error: new ApplicationError(error),
    }
  } else if (loading) {
    return { loading }
  }

  if (!productCategories) {
    return { redirect: PRODUCTS }
  }

  return {
    loading,
    error,
    productCategories,
    categoriesHierarchy,
  }
}

const withProductCategories = graphql(query, {
  options: mapPropsToOptions,
  props: mapDataToProps,
})

export default withProductCategories
